import  * as BlogPostActions from '../actions/BlogPostActions'

export interface IBlogPostsState {
    posts: Array<BlogPostActions.IBlogPostType>;
}

const initialState : IBlogPostsState = {
    posts: []
}

export const blogPostsReducer = (
    state: IBlogPostsState = initialState,
    action: BlogPostActions.ILoadRecentBlogPostsSucceededAction): IBlogPostsState => {
    switch (action.type) {
        case BlogPostActions.LOAD_RECENT_BLOG_POSTS_SUCCEEDED_ACTION_TYPE:
            return {
                posts: [
                    ...action.json.results,
                ],
            }
        default:
            return state;
    }
}